import { DocCancelavel } from './TermCancelHistoryModal';

/**
 * "Corrigir e gerar novamente" de um documento jurídico.
 *
 * O Autentique não permite trocar o arquivo de um documento já criado
 * (`updateDocument` só mexe em nome e configurações), então "editar" é
 * necessariamente **cancelar o antigo e emitir um novo**. Para o operador não
 * ter que redigitar tudo, a emissão guarda o payload que foi mandado ao n8n
 * (`payload_geracao`) e ele volta aqui para repopular o formulário.
 */
export interface RegeracaoDocumento {
    docTipo: DocCancelavel;
    /** Payload exato enviado ao webhook n8n na emissão anterior. */
    payload: Record<string, any>;
    /** Id do log cancelado que o novo documento substitui. */
    substituiLogId: number;
}

/** Texto puro de um campo do payload antigo, com fallback. */
export const doPayload = (payload: Record<string, any> | null | undefined, chave: string, padrao = ''): string => {
    const v = payload?.[chave];
    if (v === null || v === undefined) return padrao;
    return typeof v === 'string' ? v : String(v);
};

/** Array de um campo do payload antigo — devolve [] quando o campo não existe. */
export const arrayDoPayload = <T,>(payload: Record<string, any> | null | undefined, chave: string): T[] => {
    const v = payload?.[chave];
    return Array.isArray(v) ? (v as T[]) : [];
};
